import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { IPostLiabilityWaiver, PostLiabilityWaiver } from "api/rpc/2024-04/facilityAdmin/facility/liabilityWaiver";
import { StatusCode } from "api/protocols";
import Page from "components/page/Page";
import Card from "components/card/Card";
import Form from "components/form/Form";
import FormLayout from "components/form/FormLayout";
import Input from "components/form/input/Input";
import { showError } from "redux/actions/ui";
import { useAppDispatch } from "hooks/redux";
import TextEditor from "components/textEditor/textEditor";

export default function LiabilityWaiverNew() {
  const history = useHistory();
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const [liabilityWaiver, setLiabilityWaiver] = useState<IPostLiabilityWaiver>({
    title: "",
    content: "",
  });

  const primaryAction = {
    content: t("Create"),
    action: createLiabilityWaiver,
    disabled: liabilityWaiver.title === "" || liabilityWaiver.content === "",
  };

  async function createLiabilityWaiver() {
    const res = await PostLiabilityWaiver(liabilityWaiver, true);
    if (res.status !== StatusCode.OK) {
      dispatch(showError(t("Error creating liability waiver")));
      return;
    }
    history.push("/admin/settings/liability-waivers");
  }

  function setLiabilityWaiverContent(content: string) {
    setLiabilityWaiver(prevState => {
      return { ...prevState, content };
    });
  }

  return (
    <Page
      title={t("Create Liability Waiver")}
      narrow
      primaryAction={primaryAction}
      breadcrumbs={[
        {
          prefix: true,
          label: t("Liability Waivers"),
          url: "/admin/settings/liability-waivers",
        },
      ]}
    >
      <Card>
        <Card.Section>
          <Form>
            <FormLayout>
              <FormLayout.Group>
                <Input
                  label={t("Title")}
                  value={liabilityWaiver.title}
                  onChange={e => setLiabilityWaiver({ ...liabilityWaiver, title: e.target.value })}
                />
              </FormLayout.Group>
            </FormLayout>
          </Form>
        </Card.Section>

        <Card.Section>
          <TextEditor markdownText={liabilityWaiver.content} markdownTextOnChange={setLiabilityWaiverContent} />
        </Card.Section>
      </Card>
    </Page>
  );
}
